import React, { useEffect, useState } from "react";
import AOS from "aos";

import "aos/dist/aos.css";
import "./style.css";

const GlobalGold = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    useEffect(() => {
        document.getElementById("global-vid").play();
    }, []);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <div>
            <div class="bg-img">
                <div class="container">
                    <div class="cover-title">
                        <h1>
                            {lang === "Fr"
                                ? `PRINCIPALES UTILISATIONS DE L’OR`
                                : `PRINCIPAL USES OF GOLD`}
                        </h1>
                    </div>
                </div>
            </div>
            <div className="global-gold">
                <h1>
                    {lang === "Fr"
                        ? `TOP 6 DES UTILISATIONS COURANTES DE L’OR`
                        : `Top 6 Common Uses For Gold`}
                </h1>
                <video autoplay muted controls id="global-vid">
                    <source
                        src={require("../../Assets/globalGold.mp4")}
                        type="video/mp4"
                    />
                </video>
                <div className="global-card" id="card1">
                    <div className="global-content" data-aos="fade-right">
                        <h2>
                            {lang === "Fr"
                                ? `1-INVESTISSEMENT`
                                : `1-INVESTMENT`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Parce que l’or est si rare et très valorisé,
                 ce métal précieux fait une monnaie naturelle centrale,
                  il peut protéger ou améliorer la performance d’un portefeuille 
                  d’investissement et réduire la volatilité. La demande d’or a augmenté 
                  de 10% en 2021, avec des augmentations dans la plupart des domaines,
                   y compris les achats des banques centrales et les ventes de bijoux. 
                   Les banques centrales sont également une forte source de demande, 
                   les volumes ayant augmenté régulièrement au cours de la dernière décennie.`
                                : `Because gold is so rare and highly valued, this precious metal
              makes a natural currency Central, it can protect or enhance the
              performance of an investment portfolio and reduce volatility.
              Demand for gold rose 10% in 2021, with increases in most areas
              including central bank buying and jewellery sales. Central banks
              are also a strong source of demand, with volumes having increased
              steadily over the past decade`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/g-investment.png")}
                        alt=""
                        data-aos="fade-left"
                    />
                </div>
                <div className="global-card">
                    <div className="global-content" data-aos="fade-left">
                        <h2>
                            {lang === "Fr"
                                ? `2-BIJOUX, MÉDAILLES ET RÉCOMPENSES`
                                : ` 2-JEWELLERY, MEDALS AND AWARDS`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Historiquement, les bijoux en or ont été la plus forte source de demande, 
                représentant environ 50 % de la demande totale d’or consommée chaque année en bijoux. 
                Les bijoux sont le moyen le plus courant par lequel l’or atteint les consommateurs 
                et ont été une utilisation principale du métal dans diverses cultures.
                 En raison de leurs propriétés belles et durables, les bijoux en or sont une parure
                  à la fois éthérée et vénérée. En 2021, la demande de bijoux a augmenté de 52 %. Dans tout,
                   des Oscars aux médailles olympiques, l’or est reconnu pour ses qualités admirables 
                   et il occupe une place de valeur permanente aux yeux de l’humanité.`
                                : `Historically, gold jewellery has been the strongest source of
              demand, accounting for around 50 % of total demand gold consumed
              each year is made into jewelry. Jewelry is the most common way
              gold reaches consumers, and has been a primary use for the metal
              in various cultures. Because of its beautiful and durable
              properties, gold jewelry is an adornment that is both ethereal and
              revered. In 2021, jewellery demand rose 52%. In everything from
              Academy Awards to Olympic medals, gold is recognized for its
              admirable qualities and it holds a permanent place of value in
              humanity’s eyes.`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/g-jewellery.jpg")}
                        alt=""
                        data-aos="fade-right"
                    />
                </div>
                <div className="global-card">
                    <div className="global-content" data-aos="fade-right">
                        <h2>
                            {lang === "Fr"
                                ? `3-MÉDECINE ET DENTISTERIE`
                                : `3-MEDICINE AND DENTISTRY`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Dans le domaine médical, de petites quantités d’isotopes de l’or sont utilisées dans certains traitements et diagnostics de radiothérapie.`
                                : `In the medical field, small amounts of gold isotopes are used in
              certain radiation treatments and diagnosis.`}
                            <br />
                            {lang === "Fr"
                                ? `Des médicaments à base d’or sont en cours de développement pour traiter des maladies telles que la polyarthrite rhumatoïde.`
                                : `Gold-based drugs are being developed to treat diseases such
              as rheumatoid arthritis.`}
                            <br />
                            {lang === "Fr"
                                ? `Le fait que l’or soit malléable et non allergène le rend idéal pour une utilisation en dentisterie.`
                                : `Gold’s being malleable and non-allergenic makes it ideal
              for use in dentistry.`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/DENTISTRY.png")}
                        alt=""
                        data-aos="fade-left"
                    />
                </div>
                <div className="global-card">
                    <div className="global-content" data-aos="fade-left">
                        <h2>
                            {lang === "Fr" ? `4-TECHNOLOGIE` : `4-TECHNOLOGY`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `L’or est un conducteur très efficace capable de transporter de minuscules charges électriques,
                 et en raison de cette propriété, une petite quantité se trouve dans presque tous les appareils électroniques,
                  y compris les téléphones cellulaires, les téléviseurs, les unités GPS et plus encore.
                   il permet la transmission rapide et précise des données.`
                                : `Gold is a highly efficient conductor that is able to carry tiny
              electrical charges, and because of this property a small amount is
              found in almost all electronic devices, including cell phones,
              televisions, GPS units and more. it enables the rapid, accurate
              transmission of data.`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/g-technology.jpg")}
                        alt=""
                        data-aos="fade-right"
                    />
                </div>
                <div className="global-card">
                    <div className="global-content" data-aos="fade-right">
                        <h2>
                            {lang === "Fr" ? `5-AÉROSPATIALE` : `5-AEROSPACE`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Dans l’espace, des couches d’or sont utilisées pour protéger les astronautes et l’équipement de la chaleur et des radiations.`
                                : `In space, layers of gold are used to protect astronauts and
              equipment from heat and radiation.`}
                            <br />
                            {lang === "Fr"
                                ? `Les nanoparticules d’or sont utilisées pour améliorer l’efficacité des cellules et des panneaux solaires.`
                                : `Gold nanoparticles are used to improve the efficiency of solar
              cells and panels.`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/aerospace.jpg")}
                        alt=""
                        data-aos="fade-left"
                    />
                </div>
                <div className="global-card">
                    <div className="global-content" data-aos="fade-left">
                        <h2>
                            {lang === "Fr"
                                ? `6-ENVIRONNEMENT`
                                : `6-ENVIRONMENT`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Sur le plan environnemental, les nanoparticules sont utilisées pour nettoyer les eaux souterraines contaminées en décomposant les polluants.`
                                : `Environmentally, nanoparticles are used to clean contaminated
              groundwater by breaking down pollutants.`}
                        </p>
                    </div>
                    <img
                        src={require("../../Assets/Environnement.jpg")}
                        alt=""
                        data-aos="fade-right"
                    />
                </div>
            </div>
        </div>
    );
};

export default GlobalGold;
